import * as authActions from './auth/auth.actions';

export const rootAction = {
  ...authActions,
};
